export default "__VITE_ASSET__BLCyDMAv__";